<template>
  <div class="container px-0">
    <div class="row text-center about mt-3" style="height:270px">
      <div class="col-md-12 mt-1 py-1">
        <p class="about">{{ data1.about2 }}<br />{{ data1.about1 }}<br /></p>
        <br />
      </div>
    </div>
    <div class="row" style="margin-top:-170px;">
      <div class="col-md-10 offset-md-1">
        <div class="container p-0 m-0">
          <div class="row p-0 m-0">
            <div class="col-md-4 px-0 mx-0 my-2" v-for="(item, index) in projectlist.projects.slice(0, 3)" :key="index">
              <div class="mx-1 p-1 card text-center">
                <h5 class="card-title mt-1">{{ item.name }}</h5>
                <img :src="item.img" class="project-img" />
                <br />
                <a :href="item.url" target="blank" class="btn btn-primary"
                  >Explore</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row m-2">
      <div class="col-md-12 text-center">
        <router-link class="" to="/projects"
          ><h4>Want to see more?</h4></router-link
        >
      </div>
    </div>
    <hr />
  </div>
</template>

<script>
import projectlist from "@/assets/data/projects.json";
import data1 from "@/assets/data/profile.json";
export default {
  name: "projects",
  data: () => ({
    projectlist,
    data1,
  }),
};
</script>

<style>
.project-img {
  width: 100%;
  height: 150px;
}
</style>
